/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { postForm } from 'js/actions/formsAction';
import { cleanForm } from 'js/actions/formsAction';

import {
  Button,
  TextField,
  Grid2,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
} from '@mui/material';

import { makeStyles } from '@mui/styles';
import styles from './styles';
const useStyles = makeStyles(styles);

function NameConcentratorForm(props) {
  const alert = props.alert || null;

  const [level, setLevel] = useState(alert ? alert.lvl : null);
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    dispatch(postForm(values));
    props.nextStep();
  };

  useEffect(() => {
    dispatch(cleanForm());
  }, []);

  const handlLvlAlertChange = (lvlAlert) => {
    setLevel(lvlAlert.target.value);
  };

  const classes = useStyles();

  return (
    <Grid2 className={classes.root} container={true}>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <TextField
          className={classes.textField}
          {...register('name_alert')}
          label="Nombre de Alerta"
          name="name_alert"
          required
          defaultValue={alert ? alert.name : null}
          variant="outlined"
        />

        <TextField
          className={classes.textField}
          {...register('message_alert')}
          label="Mensaje "
          name="message_alert"
          defaultValue={alert ? alert.message : null}
          required
          variant="outlined"
        />

        <FormControl className={classes.textField} variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label">
            Prioridad de la alerta
          </InputLabel>
          <Select
            {...register('lvlAlert')}
            id="demo-simple-select-outlined"
            labelId="demo-simple-select-outlined-label"
            onChange={handlLvlAlertChange}
            value={level}
            name="lvlAlert"
            //labelWidth={labelWidth}
          >
            <MenuItem value="">
              <em>Seleccionar</em>
            </MenuItem>
            <MenuItem value={'1'}>1. BAJO</MenuItem>
            <MenuItem value={'2'}>2. MEDIO</MenuItem>
            <MenuItem value={'3'}>3. ALTO</MenuItem>
          </Select>
        </FormControl>

        <Button
          color="secondary"
          size="large"
          type="submit"
          variant="contained"
          className={classes.button}
        >
          Guardar y Continuar
        </Button>
      </form>
    </Grid2>
  );
}

export default NameConcentratorForm;
